import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import { ItemService } from '../../services/item.service';
import { Router } from '@angular/router';
import { Spot } from '../../models/Item';
import { Chart } from 'chart.js';



@Component({
  selector: 'app-channels',
  templateUrl: './channels.component.html',
  styleUrls: ['./channels.component.css']
})
export class ChannelsComponent implements OnInit {

  dataSource_adv_brands_tab;
  dataSource_adv_brands_days_tab;
  dataSource_adv_channel_tab;
  displayedColumns = ['brand', 'net_spend', 'avg_spend', 'total_minutes', 'count', 'sos', 'som', 'sof', 'active_days'];
  displayedColumns_day = ['day', 'net_spend', 'avg_spend', 'total_minutes', 'count', 'sos', 'som', 'sof'];
  displayedColumns_channel = ['channel', 'net_spend', 'avg_spend', 'total_minutes', 'count', 'sos', 'som', 'sof'];

  @ViewChild('sort3') sort3: MatSort;
  @ViewChild('paginator3') paginator3: MatPaginator;


  //////////////////


  dataSource_categoryToCompare_Bychannels;
  dataSource_brandToCompare_Bychannels;

  @ViewChild('sort4') sort4: MatSort;
  @ViewChild('paginator4') paginator4: MatPaginator;
  @ViewChild('sort5') sort5: MatSort;
  @ViewChild('paginator5') paginator5: MatPaginator;




  constructor(public itemService: ItemService, public router: Router, public titlecasePipe: TitleCasePipe) { }


  ngOnInit() {

    let parameters:any = { section_name: 'Advertisers', page_name: 'Channels'}
      this.itemService.logEvent('onPageView', parameters);

    if(this.itemService.remeberAdv) {
      this.itemService.selected_adv = this.itemService.remeberAdv;
    }
    this.itemService.secondary_selected_adv = null;
    this.itemService.secondary_selected_adv_brand = null;
    this.itemService.selected_adv_brand = null;
    this.itemService.selected_cat = null;
    this.itemService.showSpinner = true;
    this.itemService.url = this.router.url;


    if(this.itemService.dataAvailable){
      // console.log('Advertisers Block');
      this.itemService.advertisers();
      this.itemService.showSpinner = false;
    } else {
      // console.log('Date Change Block');      
      this.itemService.dateChangeDetector();
    }
    
    setTimeout(() => {
      
      // this.itemService.advertisers();
      this.itemService.getCategoryTable_forChannelPage();
      this.itemService.getBrandTable_forChannelPage();
      this.itemService.getAdvertisersTable_forChannelPage();
      this.itemService.selected_toCompare_category = this.itemService.aggregated_categories[0].category;
      this.itemService.selected_toCompare_brand = this.itemService.aggregated_brands[0].brand;
      this.itemService.dataSource_adv_channel_tab.sort = this.sort3;
      this.itemService.dataSource_adv_channel_tab.paginator = this.paginator3;

    }, 8000);
    setTimeout(() => {
      this.itemService.dataSource_adv_channel_tab.sort = this.sort4;
      this.itemService.dataSource_adv_channel_tab.paginator = this.paginator4;

    }, 9000);
    setTimeout(() => {
      this.itemService.dataSource_adv_channel_tab.sort = this.sort5;
      this.itemService.dataSource_adv_channel_tab.paginator = this.paginator5;
    }, 9500);

  }





  chart = [];

  // public data: any[];
  // dateSelected: any;
  public daterange: any = {};
  public advertiser: any;
  public options: any = {
    locale: { format: 'MM/DD/YYYY' },
    
    alwaysShowCalendars: false,
    startDate: this.itemService.sd,
    endDate: this.itemService.ed,
    minDate: '01/01/2017',
    opens: 'left',
    showWeekNumbers: true,
    ranges: {
      // 'Yesterday': [
      //     '2018-02-26T07:00:33.456Z',
      //     '2018-02-26T07:00:33.456Z'
      // ],
      'Last 7 Days': [
        '01/01/2017',
        '31/03/2018',
      ],
      'Last 30 Days': [
        '03/02/2018',
        '03/31/2018'
      ],
      'This Month': [
        '03/01/2018',
        '03/31/2018'
      ],
      'Last Month': [
        '02/01/2018',
        '02/28/2018'
      ]
    },
  };




  public selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start;
    datepicker.end = value.end;

    // or manupulat your own internal property
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;

    let start;
    let end;
    start = new Date(this.daterange.start);
    end = new Date(this.daterange.end);

    // start Date Function
    const sd_date = ('0' + start.getDate()).slice(-2);
    const sd_Month = ('0' + (start.getMonth() + 1)).slice(-2);
    const sd_year = start.getFullYear();

    const startDate = ((sd_Month) + '-' + sd_date + '-' + sd_year);
    this.itemService.startDate = startDate;

    // end Date Function
    const ed_date = ('0' + end.getDate()).slice(-2);
    const ed_Month = ('0' + (end.getMonth() + 1)).slice(-2);
    const ed_year = end.getFullYear();

    const endDate = ((ed_Month) + '-' + ed_date + '-' + ed_year);
    this.itemService.endDate = endDate;

    // dateChanged Function

    
    this.itemService.startDateTemp = new Date(startDate)
    this.itemService.endDateTemp = new Date(endDate)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;


    let advertiserSelected = this.itemService.selected_adv ? this.itemService.selected_adv : 'Not Selected';
    let parameters:any = { 
      section_name: 'Advertisers',
      page_name: 'Channels',
      advertiser:advertiserSelected,
      startDate: this.itemService.startDate,
      days: this.itemService.days,
      endDate: this.itemService.endDate,
    }
    this.itemService.logEvent('onDateChange', parameters);


    
    this.itemService.dateChangeDetector();


    setTimeout(() => {
      this.itemService.getAdvertisersTable_forChannelPage();
      this.itemService.getCategoryTable_forChannelPage();
      this.itemService.getBrandTable_forChannelPage();
      this.itemService.dataSource_adv_channel_tab.sort = this.sort3;
      this.itemService.dataSource_adv_channel_tab.paginator = this.paginator3;
      this.itemService.dataSource_categoryToCompare_Bychannels.sort = this.sort4;
      this.itemService.dataSource_categoryToCompare_Bychannels.paginator = this.paginator4;
      this.itemService.dataSource_categoryToCompare_Bychannels.sort = this.sort5;
      this.itemService.dataSource_categoryToCompare_Bychannels.paginator = this.paginator5;
    }, 8000);
  }


  onChange(value) {
    
    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;



    let parameters:any = { 
      section_name: 'Advertisers',
      page_name: 'Channels',
      advertiser:value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days, 
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onAdvertiserChange', parameters);

    this.itemService.genre_ByCompanyChart.destroy();
    this.itemService.region_ByCompanyChart.destroy();
    this.itemService.selected_adv = value;


    this.itemService.advertisers();
    this.itemService.getAdvertisersTable_forChannelPage();

    this.itemService.dataSource_adv_channel_tab.sort = this.sort3;
    this.itemService.dataSource_adv_channel_tab.paginator = this.paginator3;
    this.itemService.dataSource_categoryToCompare_Bychannels.sort = this.sort4;
    this.itemService.dataSource_categoryToCompare_Bychannels.paginator = this.paginator4;
    this.itemService.dataSource_categoryToCompare_Bychannels.sort = this.sort5;
    this.itemService.dataSource_categoryToCompare_Bychannels.paginator = this.paginator5;

  }


  // onChangeChannel(value) {
  //   this.itemService.selected_adv_channel = value;
  //   this.itemService.advertisers();
  //   setTimeout(() => {
  //     this.itemService.dataSource_adv_brands_tab.sort = this.sort1;
  //     this.itemService.dataSource_adv_brands_tab.paginator = this.paginator1;
  //     this.itemService.dataSource_adv_brands_days_tab.sort = this.sort2;
  //     this.itemService.dataSource_adv_brands_days_tab.paginator = this.paginator2;
  //     this.itemService.dataSource_adv_channel_tab.sort = this.sort3;
  //     this.itemService.dataSource_adv_channel_tab.paginator = this.paginator3;
  //     this.itemService.dataSource_categoryToCompare_Bychannels.sort = this.sort4;
  //     this.itemService.dataSource_categoryToCompare_Bychannels.paginator = this.paginator4;
  //     this.itemService.dataSource_categoryToCompare_Bychannels.sort = this.sort5;
  //     this.itemService.dataSource_categoryToCompare_Bychannels.paginator = this.paginator5;
  //   }, 1000);

  // }

  onChangeCategory(value) {
    
    this.itemService.selected_toCompare_category = value;
    this.itemService.advertisers();

    setTimeout(() => {
      this.itemService.getCategoryTable_forChannelPage();
      this.itemService.dataSource_categoryToCompare_Bychannels.sort = this.sort4;
      this.itemService.dataSource_categoryToCompare_Bychannels.paginator = this.paginator4;
    }, 1000);
  }

  onChangeBrand(value) {

    this.itemService.selected_toCompare_brand = value;
    this.itemService.advertisers();
    setTimeout(() => {
      this.itemService.getBrandTable_forChannelPage();
      this.itemService.dataSource_brandToCompare_Bychannels.sort = this.sort5;
      this.itemService.dataSource_brandToCompare_Bychannels.paginator = this.paginator5;
    }, 1000);
  }



}


// WEBPACK FOOTER //
// ./src/app/advertisers/channels/channels.component.ts